import type React from 'react';

import classNames from 'classnames';

import type { AssetsApprovalSchemaNullable } from '@iconik-io/iconik-api/src/services/assets';
import { Icon } from '@iconik-io/uad';

import TooltipTrigger from '../../tooltip_trigger/tooltip_trigger';

import styles from '../asset_approval_status_detailed.module.css';

const InfoStatuses: React.FC<{
  requestedBy: AssetsApprovalSchemaNullable[];
  requestedByUser: boolean;
}> = ({ requestedBy, requestedByUser }) => {
  const statuses = [];

  if (requestedBy.length > 0) {
    statuses.push(
      <div key="request-status" className={styles.status_content}>
        <TooltipTrigger
          tooltipText={
            requestedByUser ? 'Review requested by you' : 'Awaiting review'
          }
          placement="bottom"
          key="request-status"
          componentProps={{
            role: 'status',
            'aria-label': requestedByUser
              ? 'Review requested by you'
              : 'Awaiting review',
          }}
        >
          <div className={styles.status_icon}>
            <Icon
              name={
                requestedByUser
                  ? 'ra_approval_requested_to_me'
                  : 'ra_approval_requested'
              }
            />
          </div>
        </TooltipTrigger>
        {requestedBy.length > 1 ? (
          <div className={styles.counter}>{requestedBy.length}</div>
        ) : null}
      </div>,
    );
  }

  if (statuses.length > 0) {
    return (
      <div className={classNames(styles.status_info, styles.status)}>
        {statuses}
      </div>
    );
  }
  return null;
};

export default InfoStatuses;
